// eslint-disable-next-line import/prefer-default-export
export var BROKERBANS_INQ = 'BROKERBANS_INQ';
